<template>
  <el-dialog
          :visible.sync="dialogVisible"
          title="图形验证码校验"
          width='420px'
          custom-class="image-code-dialog"
  >
    <el-form
            ref="form"
            class="image-auth-code"
            :model='form'
            :rules='rules'
    >
      <el-form-item prop="imageCode">
        <el-input v-model="form.imageCode" placeholder="请输入图形验证码" />

        <p class="imageCode">
          <img :src="imageCode"
               :style="{ visibility: imageCode ? 'visible' : 'hidden' }"
               alt="image code">
        </p>

        <span class="changeImageCode" @click="getImageVeryCodeHandler">换一换</span>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary"
                 :loading="loading"
                 @click="confirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import * as loginApi from '@/util/api';
  import {debounce} from 'lodash'
  export default {
    props: {
      visible: Boolean,
      loading: Boolean
    },
    data() {
      return {
        form: {
          imageCode: ''
        },
        rules: {
          imageCode: [
            { required: true, message: '验证码不能为空' }
          ]
        },
        imageCode: '',
        verify: ''
      }
    },
    computed: {
      dialogVisible: {
        get () {
          return this.visible
        },
        set (val) {
          this.$emit('update:visible', val)
        }
      }
    },
    watch: {
      visible (val) {
        if (val) {
          this.getImageVeryCodeHandler()
        }else{
          this.$refs.form.resetFields()
        }
      }
    },
    methods: {
      getImageVeryCodeHandler: debounce(function() {
        loginApi.getImageVeryCode().then( res => {
          this.imageCode = res.data.barCode
          this.verify = res.data.verify
        })
      }, 600),
      confirm() {
        this.$refs.form.validateField('imageCode', (err) => {
          if (!err) {
            this.$emit('callback', {
              imageCode: this.form.imageCode,
              verify: this.verify,
            });
          }
        })
      },
      handleCancel() {
        this.dialogVisible = false
      },
    }
  }
</script>

<style lang="less" scoped>
  /deep/.ant-modal{
    .ant-input{
      height: 36px;
    }
    .ant-form-item-children{
      display: flex;
      margin-top: 25px;
    }

  }

  .image-auth-code {
    /deep/ .el-form-item {
      &__content {
        display: flex;
        line-height: 1;
      }

      .el-input {
        display: block;

        &__inner {
          border-radius: 0;
        }
      }

      .imageCode{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 120px;
        height: 36px;
        border: 1px solid #d9d9d9;
        border-left: none;
        cursor: pointer;

        img{
          display: block;
          height: 32px;
        }
      }

      .changeImageCode{
        display: flex;
        align-items: center;
        width: 100px;
        margin-left: 12px;
        user-select: none;
        cursor: pointer;
      }
    }
  }

  /deep/ .image-code-dialog {
    margin-top: 0 !important;
    top: 50%;
    transform: translateY(-50%);
  }
</style>